const { h, render, Component } = require('preact');
const SupportAPIHelper = require('../../../../../support/frontend/helpers/API')
const touch2017Utils = require('../../../../../touch_2017/frontend/utils')
const StatusInfo = require('../../views/main/status_info')

class GoodsOrderStatus extends Component {
  constructor(props) {
    super(props);
    this.dealSuccessCallback = this.dealSuccessCallback.bind(this);
  }

  componentWillMount() {
    let order = this.props.order
    let fulfillmenturl = `${Groupon.Utils.getConfigFromDom().SUPPORTBASEURL}/orders/${order.id}/fulfillments`
    let errorCb = (response) => {
      this.fulfillmentErrorCallback()
    }
    let successCb = (response) => {
      if (response) {
        if (response.deliveryRange) {
          this.setState({fullfillment: response, type: 'DELIVERY'})
        }
        else {
          this.fulfillmentErrorCallback()
        }
      }
    }
    SupportAPIHelper.get(fulfillmenturl, null, successCb, errorCb, false);
  }

  fulfillmentErrorCallback() {
    const currentOrder = this.props.order
    let queryParam = ""
    if(currentOrder.deal.id && currentOrder.purchasedAt) {
      if(currentOrder.expressDeliveryDate)
        queryParam = `&expressDeliveryDate=${currentOrder.expressDeliveryDate}`
      let url = `${Groupon.Utils.getConfigFromDom().SUPPORTBASEURL}/deal/${currentOrder.deal.id}?purchasedAt=${currentOrder.purchasedAt}`+queryParam
      let errCb = () =>{}
      SupportAPIHelper.get(url, null, this.dealSuccessCallback, errCb, false);
    }
  }

  dealSuccessCallback(deal) {
    if (deal.expressDeliveryDate) {
      this.setState({type: 'EXPRESS_DELIVERY'})}
    else if (deal.deliveryRange) {
      this.setState({type: 'ESTIMATED_DELIVERY'})
    } else {
      this.setState({type: 'DEFAULT'})
    }
    this.setState({deal: deal})
  }

  componentDidUpdate(){
    touch2017Utils.localizeUTCDates('MMM DD, YYYY')
  }

  render() {
    if (this.state.type == 'DELIVERY') {
      return (
        <div class="date-info">
          {this.state.fullfillment.deliveryRange.text}:
          <span dangerouslySetInnerHTML={{__html: this.state.fullfillment.deliveryRange.dateString}}/>
        </div>
      )
    }
    else if (this.state.type == 'EXPRESS_DELIVERY') {
      return (
        <div class="date-info">
          {I18n.translate('js.modules.support.delivery_date')}: {this.state.deal.expressDeliveryDate} {I18n.translate('js.modules.support.express_shipping')}
        </div>
      )
    }
    else if (this.state.type == 'ESTIMATED_DELIVERY') {
      return (
        <div class="date-info">
          {I18n.translate('js.modules.support.estimated_delivery')}: {this.state.deal.deliveryRange}
        </div>
      )
    }
    else return (<StatusInfo order={this.props.order}/>)
  }
}
module.exports = GoodsOrderStatus
